<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.6709 10.3334H10.1709V10.8334V13.6668C10.1709 13.8073 10.0614 13.9168 9.92092 13.9168C9.78039 13.9168 9.67092 13.8073 9.67092 13.6668V10.8334V10.3334H9.17092H6.33759C6.19706 10.3334 6.08759 10.224 6.08759 10.0834C6.08759 9.94291 6.19706 9.83344 6.33759 9.83344H9.17092H9.67092V9.33344V6.33344C9.67092 6.19291 9.78039 6.08344 9.92092 6.08344C10.0614 6.08344 10.1709 6.19291 10.1709 6.33344V9.33344V9.83344H10.6709H13.6709C13.8114 9.83344 13.9209 9.94291 13.9209 10.0834C13.9209 10.224 13.8114 10.3334 13.6709 10.3334H10.6709Z" fill="#109CF1" stroke="#109CF1"/>
  </svg>
</template>

<script>
  export default {
    name: "plusIconSmall"
  }
</script>

<style scoped>

</style>
